
import '../App.css';


function Banner() {
  return (
    <div className="Banner">
        <img className="Banner-Logo" src="brand_n.png" alt="" srcset="" />
        <h1 className='Banner-Title'>Hi 👋 I’m Neeraj! </h1>
        <p className='Banner-Subtitle'>Develop. Preview. Ship.</p>
        <br/>
        <p className='Banner-Intro'>I am an Aspiring Full-Stack Software Engineer with a keen interest in building robust and user-focused applications with a strong emphasis on design, usability, and efficiency. Having worked with different technologies across the spectrum, I have found my passion in web development, and ever since then I have been highly focused towards specializing in this domain. Apart from coding, in my leisure time, I enjoy traveling and watching sci-fi movies!</p>
    </div>
  );
}

export default Banner;
